import useVideoContext from './useVideoContext';
import useDominantSpeaker from './useDominantSpeaker';
import useParticipants from './useParticipants';
import useScreenShareParticipant from './useScreenShareParticipant'; //import useSelectedParticipant from '../../components/VideoProvider/useSelectedParticipant/useSelectedParticipant';

export default function useMainSpeaker() {
  //const [selectedParticipant] = useSelectedParticipant();
  var screenShareParticipant = useScreenShareParticipant();
  var dominantSpeaker = useDominantSpeaker();
  var participants = useParticipants();

  var _useVideoContext = useVideoContext(),
      localParticipant = _useVideoContext.room.localParticipant; // if the screen share particiapnt is local, don't choose them as main participant


  var filteredScreenShareParticipant = localParticipant !== screenShareParticipant ? screenShareParticipant : undefined; // The participant that is returned is displayed in the main video area. Changing the order of the following
  // variables will change the how the main speaker is determined.

  var mainSpeaker =
  /* selectedParticipant || */
  filteredScreenShareParticipant || dominantSpeaker || participants[0] || localParticipant;
  return mainSpeaker;
}